(() => {
  const init = () => {
    if (!document.querySelector('.sm-home-scope')) return;
    document.querySelectorAll('header .menu-drawer-button, header .search-drawer-button, header .cart-drawer-button').forEach(button => {
      if (button.querySelector('.sm-home-navlabel')) return;
      const label = document.createElement('span');
      label.className = 'sm-home-navlabel';
      label.textContent = button.matches('.menu-drawer-button') ? 'Menu' : button.matches('.search-drawer-button') ? 'Søg' : 'Kurv';
      button.append(label);
    });
    document.querySelectorAll('[data-sm-home-reviews]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const rail = slider.querySelector('.sm-home-review-rail');
      const cards = [...rail.children];
      const dots = [...slider.querySelectorAll('[data-review-dot]')];
      const prev = slider.querySelector('[data-review-prev]');
      const next = slider.querySelector('[data-review-next]');
      let current = 0;
      const go = index => {
        current = Math.max(0, Math.min(cards.length - 1, index));
        rail.scrollTo({left: cards[current].offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => go(current - 1));
      next.addEventListener('click', () => go(current + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
      const sync = () => {
        const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : 1;
        current = Math.round(rail.scrollLeft / step);
        dots.forEach((dot, i) => i === current ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      };
      rail.addEventListener('scroll', sync, {passive: true});
      new ResizeObserver(sync).observe(rail);
      sync();
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
